var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTolIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#2AFC98"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.7215 40.3293H19.3306L23.6214 16C24.1701 17.8294 24.4554 18.7386 25.0041 20.5679H49.6735C50.0027 18.7386 50.1564 17.8294 50.4856 16H12.8011C12.4829 17.8294 12.3182 18.7386 12 20.5679H18.2112L14.7215 40.3293Z",
    fill: "#023C20"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7887 42.6078L49.2785 22.8902H44.6694C43.2428 31.0036 41.8125 39.1134 40.3786 47.2195H51.1989C51.5171 45.3902 51.6818 44.481 52 42.6516L45.7887 42.6078Z",
    fill: "#023C20"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3045 42.6078C13.9753 44.4372 13.8217 45.3464 13.4925 47.1757H40.3566L38.8093 42.6078H14.3045Z",
    fill: "#023C20"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2373 40.3293L42.31 22.8026H24.7517C23.5226 29.8023 22.908 33.2967 21.668 40.3293H39.2373ZM28.4718 27.3814H36.9547L35.4732 35.7943H26.9904L28.4718 27.3814Z",
    fill: "#023C20"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTolIcon);
export default __webpack_public_path__ + "static/media/TOL-Icon.dd696d04646bda8191d74043cf0e3b64.svg";
export { ForwardRef as ReactComponent };